import {GET, POST} from '../index'

export const getJobPositionList = (data) => {
  return GET('/jobPosition/list', data)
}

export const updateJobPosition = (data) => {
  return POST('/jobPosition/update', data)
}

export const delJobPosition = (id) => {
  return POST(`/jobPosition/${id}/destroy`)
}

export const createJobPosition = (data) => {
  return POST('/jobPosition/store', data)
}



// WEBPACK FOOTER //
// ./src/api/jobPosition/index.js